<div class="select-wrapper">
    <div
        class="select"
        [class.open]="isOpen"
    >
        <div
            class="selected"
            (click)="open()"
        >
            <span [textContent]="selected ? selected.title : placeholder "></span>
            <span
                *ngIf="showIcon"
                class="chevron bottom"
            ></span>
        </div>
        <div
            class="options"
            [class.full]="isShowFullScreen"
        >
            <ul [style.padding-bottom.px]="navigationBarService.isShow ? 80 : 0">
                <ng-template
                    ngFor
                    [ngForOf]="items"
                    let-item
                >
                    <li
                        (click)="[selectedChange.emit(item), isOpen = false, selectId = '']"
                        [attr.id]="(selected?.id === item.id) ? selectId : ''"
                    >
                        <span
                            [class.selected]="selected?.id === item.id"
                            class="option"
                            [textContent]="item.title"
                        ></span>
                    </li>
                </ng-template>
            </ul>
        </div>
    </div>
</div>
